const state = {
  tiposTelefone: [
    { id_tipo_telefone: 1, descricao: 'GERAL' },
    { id_tipo_telefone: 2, descricao: 'RESIDENCIAL' },
    { id_tipo_telefone: 3, descricao: 'CELULAR' },
    { id_tipo_telefone: 4, descricao: 'TRABALHO' },
    { id_tipo_telefone: 5, descricao: 'OUTROS' },
  ]
};

const getters = {
  tiposTelefone: state => state.tiposTelefone,
};

const actions = {};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
}